var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status !== null)?_c('span',[(_vm.failed)?_c('i',{staticClass:"fi-x",attrs:{"title":_vm.status}}):(_vm.working)?_c('i',{staticClass:"fi-loop",attrs:{"title":_vm.status}}):_c('boolean-icon',{attrs:{"bool":_vm.complete,"color":true,"title":_vm.status}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }